import React from 'react'
import { FlexCenter, Padding } from '../../../styles/CommonStyles'
import { DetailsButton, DetailText } from '../../../styles/TransactionHistoryStyles'
import { Text, useMainContext } from '../../../modules/staking'
import { ItemRow } from '../../../styles/newStyles/MobileModal.styled'
import { SOCKET_URL } from '../../../core/constants/urls'
import { Market, TextWithMargin } from '../../../styles/OrdersStyle'
import TruncateMiddle from '../../common/TruncateMiddle'
import { formatDate, formatNumber } from '../../../core/utils/common'
import { useQueryContext } from '../../../core/contexts/query'

const TransferDetailsModal = ({ data, profileId, onClose }) => {

  const {
    main: { lang },
  } = useMainContext()

  const { setToast } = useQueryContext()

  const onCopyToClipboard = (value) => {
    navigator.clipboard.writeText(value)
    setToast({
      show: true,
      message: 'copy-success',
    })
  }


  return (
    <div>
      <FlexCenter width='100%'>
        <Padding padding='10px 0' style={{ borderBottom: '1px solid #ffffff15' }}>
          <DetailText>
            <Text tid='see-details' />
          </DetailText>
        </Padding>
      </FlexCenter>
      <div className='p-2 bg-slate-100 dark:bg-transparent rounded-xl mb-4'>
        <ItemRow className='dark:border-b dark:border-card-border'>
          <div>
            <Text tid='coin' className='text-pcolor-light text-sm' />
          </div>
          <FlexCenter>
            <img
              src={
                data?.currency === 'irt'
                  ? require('../../../assets/images/tooman.png')
                  : SOCKET_URL + `assets/icon/${data?.currency}.png`
              }
              alt={data?.currency}
              className='w-6 h-6'
            />
            <Market>{data?.currency.toUpperCase()}</Market>
          </FlexCenter>
        </ItemRow>
        <ItemRow className='dark:border-b dark:border-card-border'>
          <Text tid='transfer-type' className='text-pcolor-light text-sm' />
          <FlexCenter>
            <TextWithMargin type={data?.toId === profileId ? 'receive' : 'send'}>
              {data?.toId === profileId ? <Text tid='receive' /> : <Text tid='send' />}
            </TextWithMargin>
          </FlexCenter>
        </ItemRow>
        <ItemRow className='dark:border-b dark:border-card-border'>
          <Text
            tid={data?.toId === profileId ? 'sender' : 'receiver'}
            className='text-pcolor-light text-sm'
          />
          <FlexCenter className='text-sm'>
            {data?.toId === profileId
              ? `${data?.from.firstName || '--'} ${data?.from.lastName || '--'}`
              : `${data?.to.firstName || '--'} ${data?.to.lastName || '--'}`}
          </FlexCenter>
        </ItemRow>
        <ItemRow className='dark:border-b dark:border-card-border'>
          <Text tid='id' className='text-pcolor-light text-sm' />
          <TruncateMiddle
            text={data?._id}
            frontChars={6}
            backChars={6}
            onClick={onCopyToClipboard.bind(null, data?._id)}
          />
        </ItemRow>
        <ItemRow className='dark:border-b dark:border-card-border'>
          <Text tid='date' className='text-pcolor-light text-sm' />
          {formatDate(data?.createdAt, 'date', lang === 'en' ? 'en-US' : 'fa-IR')}
        </ItemRow>
        <ItemRow className='dark:border-b dark:border-card-border'>
          <Text tid='timeHour' className='text-pcolor-light text-sm' />
          {formatDate(data?.createdAt, 'time', lang === 'en' ? 'en-US' : 'fa-IR')}
          {console.log(data)}
        </ItemRow>
        <ItemRow className='dark:border-b dark:border-card-border'>
          <Text tid='amount' className='text-pcolor-light text-sm' />
          {data?.amount ? formatNumber(data?.amount) : '--'}
        </ItemRow>
        <ItemRow>
          <Text tid='note' className='text-pcolor-light text-sm' />
          {data?.note}
        </ItemRow>
      </div>
    </div>
  )
}

export default TransferDetailsModal